import dayjs from 'dayjs';
import 'dayjs/locale/es';           // para tener meses/días en español (opcional pero útil)
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

// Extiende una sola vez
dayjs.extend(isSameOrBefore);
dayjs.locale('es');  // opcional, pero recomendado si usas formatos en español

export default dayjs;